'use client';

import React from "react";

type GalleryVideoProps = {
  src: string;
  className?: string;
};

export default function GalleryVideo({ src, className }: GalleryVideoProps) {
  const videoRef = React.useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = React.useState(false);

  const onPlayClick = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
      setIsPlaying(false);
      return;
    }
    const playPromise = videoRef.current.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(() => setIsPlaying(true)).catch(() => {});
    } else {
      setIsPlaying(true);
    }
  };

  return (
    <div className={`relative ${className ?? ''}`}>
      <video
        ref={videoRef}
        className="w-full rounded-lg shadow-lg"
        loop
        muted
        controls={isPlaying}
        playsInline
      >
        <source src={src} type="video/webm" />
        Your browser does not support the video tag.
      </video>

      {!isPlaying && (
        <div className="absolute inset-0 flex items-center justify-center">
          <button
            type="button"
            onClick={onPlayClick}
            className="w-16 h-16 rounded-full bg-primary text-white shadow-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-primary flex items-center justify-center"
            aria-label="Play video"
          >
            {/* Play icon */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-7 h-7 translate-x-[1px]"
              aria-hidden="true"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>
        </div>
      )}
    </div>
  );
}


